import React, { useEffect, FC, useCallback, useState } from "react";
import { Modal, ModalBody, Alert } from "reactstrap";
import { Icon, Button } from "../../../components/Component";
import { Row, Col } from "reactstrap";
import { FormProvider, useForm } from "react-hook-form";
import FormSelect from "../../form-components/SelectComponent";
import FormInput from "../../form-components/InputComponent";
import FormTextArea from "../../form-components/TextAreaComponent";
import workCategoryApi from "../../../api/master/workCategory";

const AddModal: FC<any> = ({
  modal,
  closeModal,
  onSubmit,
  formData,
  alertInfo,
  hasSequence,
}) => {
  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = methods;

  const [categoryType, setCategoryType] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Reset form when modal opens
  useEffect(() => {
    if (modal) {
      reset({
        referenceID: "",
        categoryName: "",
        description: "",
        workCategoryID: "",
      });
    }
  }, [modal, reset]);

  const getcategoryType = useCallback(async () => {
    try {
      const matCats = await workCategoryApi.fetchCategoryType();
      if (matCats.status && matCats.data.length > 0) {
        const transformedData = matCats.data.map((item: any) => ({
          value: item.workCategoryId.toString(),
          label: item.workCategoryName,
        }));
        setCategoryType(transformedData);
      }
    } catch (error: any) {
      console.error("Failed to fetch org types:", error.message);
    }
  }, []);

  useEffect(() => {
    getcategoryType();
  }, [getcategoryType]);

  return (
    <Modal
      isOpen={modal}
      toggle={() => closeModal()}
      className="modal-dialog-centered"
      size="xl"
      backdrop="static"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">Add Work Category</h5>
          {alertInfo.message && (
            <div className="mb-3 mt-1">
              <Alert
                color={alertInfo.type === "error" ? "danger" : "success"}
                className="alert-icon"
              >
                <strong>{alertInfo.message}</strong>
                <Icon
                  name={
                    alertInfo.type === "error" ? "alert-circle" : "check-circle"
                  }
                />
                {alertInfo.errors.length > 0 ? (
                  <ul>
                    {alertInfo.errors.map((err: any, index: any) => (
                      <li key={index}>{err}</li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </Alert>
            </div>
          )}
          <div className="mt-4">
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  {!hasSequence && (
                    <Col md="4">
                      <FormInput
                        name="referenceID"
                        label="Work Category ID"
                        required={true}
                        type="text"
                        placeholder="Enter Work Category ID"
                      />
                    </Col>
                  )}
                  <Col md="4">
                    <FormSelect
                      name="workCategoryID"
                      label="Work Type"
                      required={true}
                      options={categoryType}
                      placeholder="Select Work Type"
                    />
                  </Col>
                  <Col md="4">
                    <FormInput
                      name="categoryName"
                      label="Category Name"
                      required={true}
                      type="text"
                      placeholder="Enter Category Name"
                    />
                  </Col>
                  <Col md="12" className="mb-2">
                    <FormTextArea
                      name="description"
                      label="Description"
                      required={true}
                      placeholder="Write your description"
                    />
                  </Col>
                  <Row className="mt-2">
                    <Col>
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <Button color="primary" size="md" type="submit">
                            Add
                          </Button>
                        </li>
                        <li>
                          <a
                            href="#cancel"
                            onClick={(ev) => {
                              ev.preventDefault();
                              closeModal();
                            }}
                            className="link link-light"
                          >
                            Cancel
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Row>
              </form>
            </FormProvider>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddModal;